import {Context} from '../../../../Helpers/Auth';
import SelectComponent from '../../../Selects/SelectComponent';
import React, {useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {getContactosId} from '../../../../pages/requests';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Datepicker from 'react-tailwindcss-datepicker';
import {useEffect} from 'react';
import MultiSelect from '../../../Selects/MultiSelect';

function Contactos({info}) {
    const {t} = useTranslation();
    const history = useHistory();
    const {
        editarProspect,

        setLinhasContactos,
        linhasContactos,

        funcoes,
        interesses,

        setValidacaoTlm,
        validacaoTlm,
        msgTlm,

        setValidacaoEmail,
        validacaoEmail,
        msgEmail,

        setValidacaoNome,
        validacaoNome,
        setValidacaoFuncao,
        validacaoFuncao,
        setValidacaoCortesia,
        validacaoCortesia,
        optionsCortesia,

        setValidacaoApelido, //????
        validacaoApelido, //????

        setOnChangeForm,
    } = info;

    const [codigoContacto, setCodigoContacto] = useState('');
    const [nomeContacto, setNomeContacto] = useState('');
    const [apelidoContacto, setApelidoContacto] = useState('');
    const [telefone, setTelefone] = useState('');
    const [cortesia, setCortesia] = useState(null);
    const [funcaoContacto, setFuncaoContacto] = useState(null);
    const [telemovelContacto, setTelemovelContacto] = useState('');
    const [emailContacto, setEmailContacto] = useState('');
    const [contactoDefeitoContacto, setContactoDefeitoContacto] = useState(false);
    const [questionariosContacto, setQuestionariosContacto] = useState(false);
    const [nascimentoContacto, setNascimentoContacto] = useState(null);
    const [interessesContacto, setInteressesContacto] = useState(null);

    function atualizaContacto() {
        if (codigoContacto !== '') {
            setLinhasContactos(
                linhasContactos.map(m =>
                    m.id !== codigoContacto
                        ? {
                              ...m,
                              contactoDefeito: contactoDefeitoContacto ? false : m.contactoDefeito,
                          }
                        : {
                              id: codigoContacto,
                              nome: nomeContacto,
                              apelido: apelidoContacto,
                              telemovel: telemovelContacto,
                              telefone: telefone,
                              cortesia: cortesia,
                              email: emailContacto.toLowerCase(),
                              funcao: funcaoContacto,
                              contactoDefeito: contactoDefeitoContacto,
                              questionarios: questionariosContacto,
                              nascimento: nascimentoContacto,
                              interesses: interessesContacto,
                          },
                ),
            );
        }
    }
    useEffect(() => {
        if (codigoContacto !== '') {
            atualizaContacto();
        }
    }, [
        codigoContacto,
        nomeContacto,
        apelidoContacto,
        telemovelContacto,
        telefone,
        cortesia,
        emailContacto,
        funcaoContacto,
        contactoDefeitoContacto,
        questionariosContacto,
        nascimentoContacto,
        interessesContacto,
    ]);

    function limparCampos() {
        setNomeContacto('');
        setApelidoContacto('');
        setFuncaoContacto(null);
        setCortesia(null);
        setTelemovelContacto('');
        setTelefone('');
        setEmailContacto('');
        setNascimentoContacto({startDate: null, endDate: null});
        setContactoDefeitoContacto(false);
        setQuestionariosContacto(false);
    }

    //Adicionar nova linha
    async function adicionarLinha() {
        var tudoValidado = true;

        // valida apelido
        if (!apelidoContacto) {
            // marcar como não valido
            tudoValidado = false;
            setValidacaoApelido(true);
        }

        // valida formato telemovel
        if ((!!telemovelContacto && !/^\+?[0-9]+$/.test(telemovelContacto)) || telemovelContacto.length < 9) {
            // marcar como não valido
            setValidacaoTlm(true);
            tudoValidado = false;
            toast.warn(t('validacaoContacto'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        }

        // valida formato email
        if (!!emailContacto && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(emailContacto)) {
            // marcar como não valido
            tudoValidado = false;
            setValidacaoEmail(true);
            toast.warn(t('validacaoEmail'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        }
        // valida validata tel ou email (pelo menos 1 preenchido)
        if (!telemovelContacto && !emailContacto) {
            // marcar como não valido
            tudoValidado = false;
            toast.warn(t('validacaoContactoEmail'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
            setValidacaoEmail(true);
            setValidacaoTlm(true);
        }

        if (tudoValidado) {
            // grava o contacto
            var comps = [];

            linhasContactos.forEach(element => {
                if (element.id != '') {
                    const contactosJaExistentes = {
                        id: element.id,
                        // codigoContacto: element.codigoContacto.toUpperCase(),
                        nome: element.nome,
                        apelido: element.apelido,
                        telemovel: element.telemovel,
                        email: element.email.toLowerCase(),
                        funcao: element.funcao,
                        contactoDefeito: contactoDefeitoContacto ? false : element.contactoDefeito,
                        questionarios: element.questionarios,
                        nascimento: element.nascimento,
                        interesses: element.interesses,
                    };
                    comps.push(contactosJaExistentes);
                }
            });

            var contactoID;
            await getContactosId().then(res => {
                contactoID = res.data.codContacto;
            });
            const novoContacto = {
                id: contactoID,
                //codigoContacto: codigoContacto.toUpperCase(),
                nome: nomeContacto,
                apelido: apelidoContacto,
                telemovel: telemovelContacto,
                telefone: telefone,
                cortesia: cortesia,
                email: emailContacto.toLowerCase(),
                funcao: funcaoContacto,
                contactoDefeito: contactoDefeitoContacto,
                questionarios: questionariosContacto,
                nascimento: nascimentoContacto,
                interesses: interessesContacto,
            };
            comps.push(novoContacto);

            //Linha Vazia
            const linhaContactoVazia = {
                id: '',
                codigoContacto: '',
                nome: '',
                apelido: '',
                telemovel: '',
                telefone: '',
                cortesia: null,
                email: '',
                funcao: null,
                contactoDefeito: false,
                questionarios: false,
                nascimento: null,
                interesses: [],
            };
            comps.push(linhaContactoVazia);

            setLinhasContactos(comps);

            limparCampos();
        }
        return;
    }

    function EliminarLinha(linha) {
        if (linha.id !== '') {
            setLinhasContactos(linhasContactos.filter(l => l.id !== linha.id));
        }

        limparCampos();
    }

    async function EditarLinha(linha) {
        debugger;
        setCodigoContacto(linha.id);
        setNomeContacto(linha.nome);
        setApelidoContacto(linha.apelido);
        setFuncaoContacto(linha.funcao);
        setCortesia(linha.cortesia);
        setTelefone(linha.telefone);
        setTelemovelContacto(linha.telemovel);
        setEmailContacto(linha.email);
        debugger;
        setContactoDefeitoContacto(linha.contactoDefeito);
        setQuestionariosContacto(linha.questionarios);

        setNascimentoContacto(linha.nascimento);
        setInteressesContacto(linha.interesses);
    }

    console.log(linhasContactos);

    return (
        <>
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div className="relative  overflow-x-auto shadow-md sm:rounded-[8px] z-0">
                    <table className="w-full  text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-2 py-3">
                                    {t('cargo')}
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('cortesia')}
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('nome')}
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('apelido')}
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('email')}
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('telefone')}
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('telemovel')}
                                </th>

                                <th scope="col" className=" py-3"></th>
                                <th scope="col" className=" py-3"></th>
                            </tr>
                        </thead>

                        <tbody>
                            {linhasContactos?.map(dados => (
                                <tr
                                    className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                    onClick={() => {
                                        debugger;
                                        EditarLinha(dados);
                                    }}>
                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {dados?.funcao?.label}
                                    </th>{' '}
                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {dados?.cortesia?.label}
                                    </th>
                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {dados?.nome ? dados.nome : '-'}
                                    </th>
                                    <th scope="row" className="px-2 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {dados.apelido}
                                    </th>
                                    <th scope="row" className="px-2 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white ">
                                        {dados.email ? <a href={`mailto:${dados.email}`}>{dados.email}</a> : '-'}
                                    </th>
                                    <th scope="row" className="px-2 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white ">
                                        {dados.telefone ? <a href={`tel:${dados.telefone}`}>{dados.telefone}</a> : '-'}
                                    </th>
                                    <td className="px-2 py-1">
                                        <div className="flex flex-row items-center justify-between ">
                                            {dados.telemovel ? <a href={`tel:${dados.telemovel}`}>{dados.telemovel}</a> : '-'}
                                            <div className="flex flex-row items-center">
                                                <button
                                                    disabled={!editarProspect}
                                                    onClick={e => {
                                                        e.stopPropagation();

                                                        EliminarLinha(dados);
                                                    }}
                                                    className={` ml-2 hover:text-red-800 text-red-600 hover:dark:text-red-700 py-1 ${!editarProspect ? 'disabled' : ''}`}>
                                                    <DeleteForeverIcon />
                                                </button>
                                                <div
                                                    onClick={e => {
                                                        debugger;
                                                        e.stopPropagation();
                                                        EditarLinha(dados);
                                                        setOnChangeForm(true);
                                                    }}
                                                    className="ml-2 hover:text-blue-800 text-blue-600 hover:dark:text-blue-700 py-1">
                                                    <SearchRoundedIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div>
                    <div className="grid gap-6 mb-3 md:grid-cols-2">
                        <div>
                            <label htmlFor="nome" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`}>
                                {t('nome')}*
                            </label>
                            <input
                                value={nomeContacto}
                                maxLength={20}
                                type="text"
                                id="nome"
                                required
                                className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                                }${
                                    validacaoNome ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                                }`}
                                onChange={e => {
                                    setNomeContacto(e.target.value);
                                    setOnChangeForm(true);
                                    setValidacaoNome(false);
                                }}
                                disabled={!editarProspect}
                            />
                        </div>
                        <div>
                            <label htmlFor="apelido" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('apelido')}*
                            </label>
                            <input
                                value={apelidoContacto}
                                maxLength={60}
                                type="text"
                                id="apelido"
                                className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                                }${
                                    validacaoApelido
                                        ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                        : ''
                                }`}
                                required
                                onChange={e => {
                                    setApelidoContacto(e.target.value);
                                    setOnChangeForm(true);
                                    setValidacaoApelido(false);
                                }}
                                disabled={!editarProspect}
                            />
                        </div>
                        <div>
                            <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('funcao')}*
                            </label>
                            <SelectComponent
                                isDisabled={!editarProspect}
                                options={funcoes}
                                value={funcaoContacto}
                                onChange={e => {
                                    setValidacaoFuncao(false);
                                    setFuncaoContacto(e);
                                    setOnChangeForm(true);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                            />
                            {validacaoFuncao ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                        </div>
                        <div>
                            <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('cortesia')}*
                            </label>
                            <SelectComponent
                                isDisabled={!editarProspect}
                                options={optionsCortesia}
                                value={cortesia}
                                onChange={e => {
                                    setValidacaoCortesia(false);
                                    setCortesia(e);
                                    setOnChangeForm(true);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                            />
                            {validacaoCortesia ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                        </div>
                        <div>
                            <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('telemovel')}
                            </label>
                            <input
                                value={telemovelContacto}
                                maxLength={20}
                                type="tel"
                                id="phone"
                                className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    validacaoTlm ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                                }${editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'}`}
                                pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                                required
                                onChange={e => {
                                    setValidacaoTlm(false);
                                    setValidacaoEmail(false);
                                    setTelemovelContacto(e.target.value);
                                    setOnChangeForm(true);
                                }}
                                disabled={!editarProspect}
                            />
                            {validacaoTlm ? <small className="text-red-500">{msgTlm}</small> : null}
                        </div>
                        <div>
                            <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('telefone')}
                            </label>
                            <input
                                value={telefone}
                                maxLength={20}
                                type="tel"
                                id="phone"
                                className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
                                }`}
                                pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                                required
                                onChange={e => {
                                    setTelefone(e.target.value);
                                    setOnChangeForm(true);
                                }}
                                disabled={!editarProspect}
                            />
                        </div>
                        <div>
                            <label htmlFor="dataNascimento" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('dataNascimento')}
                            </label>

                            <Datepicker
                                id={'dataNascimento'}
                                displayFormat="DD/MM/YYYY"
                                useRange={false}
                                asSingle={true}
                                value={{
                                    startDate: nascimentoContacto,
                                    endDate: nascimentoContacto,
                                }}
                                onChange={newValue => {
                                    setNascimentoContacto(newValue?.startDate);
                                    setOnChangeForm(true);
                                }}
                                inputClassName={`rounded-[8px] w-full  border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    editarProspect ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                } `}
                                disabled={!editarProspect}
                            />
                            {validacaoTlm ? <small className="text-red-500">{msgTlm}</small> : null}
                        </div>
                    </div>
                    <div>
                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('email')}
                        </label>
                        <input
                            value={emailContacto}
                            maxLength={80}
                            type="tel"
                            id="email"
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                validacaoEmail ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                            }${editarProspect ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'}`}
                            required
                            onChange={e => {
                                setValidacaoTlm(false);
                                setValidacaoEmail(false);
                                setEmailContacto(e.target.value);
                                setOnChangeForm(true);
                            }}
                            disabled={!editarProspect}
                        />
                        {validacaoEmail ? <small className="text-red-500">{msgEmail}</small> : null}
                    </div>

                    <div>
                        <label htmlFor="last_name" className="block mb-2 text-sm font-medium mt-2 text-gray-900 dark:text-white">
                            {t('interesses')}
                        </label>
                        <MultiSelect
                            isDisabled={!editarProspect}
                            options={interesses}
                            value={interessesContacto}
                            onChange={e => {
                                setOnChangeForm(true);
                                setInteressesContacto(e);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                    </div>

                    <div className="flex items-center mb-4 mt-4">
                        <input
                            disabled={!editarProspect}
                            onChange={e => {
                                setQuestionariosContacto(e.target.checked);
                                setOnChangeForm(true);
                            }}
                            id="questionarios"
                            type="checkbox"
                            checked={questionariosContacto}
                            value={questionariosContacto}
                            className={`w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 ${
                                !editarProspect ? 'disabled' : ''
                            }`}
                        />
                        <label htmlFor="questionarios" className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                            {t('questionarios')}
                        </label>
                    </div>
                    <div className="flex items-center mb-4 mt-4">
                        <input
                            disabled={!editarProspect}
                            onChange={e => {
                                debugger;
                                setContactoDefeitoContacto(e.target.checked);
                                setOnChangeForm(true);
                            }}
                            id="contactoPDefeito"
                            type="checkbox"
                            checked={contactoDefeitoContacto}
                            value={contactoDefeitoContacto}
                            className={`w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 ${
                                !editarProspect ? 'disabled' : ''
                            }`}
                        />
                        <label htmlFor="contactoPDefeito" className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                            {t('contactoPDefeito')}
                        </label>
                    </div>

                    {codigoContacto == '' && (
                        <div className="flex flex-row justify-end">
                            <button
                                disabled={!editarProspect}
                                id="adicionarLinha"
                                type="button"
                                onClick={() => {
                                    adicionarLinha();
                                }}
                                className=" flex items-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                {t('registarContacto')}
                            </button>
                        </div>
                    )}
                </div>
                <ToastContainer />
            </div>
        </>
    );
}

export default Contactos;
